export const MAX_RELE = 4
export const MAX_INVERSOR = 5
export const INVERSOR_PINO_INICIAL = 5
export const WEG_XMAX = 60
export const WEG_YMAX = 8192

export const CORES_COMANDO = {
  ligar: '#A4DD00',
  desligar: '#D33115',
  rotacao: '#73D8FF',
  ativarCmdAuto: '#68BC00',
  desativarCmdAuto: '#E27300',
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value || 0))
}

function sufixo(indice, total) {
  return total === 1 ? '' : ` ${indice}`
}

function criarBotao(nome, acao, cor, xMax = null, yMax = null) {
  return {
    nomeExibicao: nome,
    acao,
    cor,
    xMAX: xMax,
    yMAX: yMax,
  }
}

export function gerarBotoesTemplate({
  quantidadeRele = 0,
  quantidadeInversor = 0,
  incluirCmdAuto = false,
} = {}) {
  const rele = clamp(quantidadeRele, 0, MAX_RELE)
  const inversor = clamp(quantidadeInversor, 0, MAX_INVERSOR)
  const botoes = []

  for (let i = 1; i <= rele; i += 1) {
    const label = sufixo(i, rele)
    botoes.push(
      criarBotao(
        `Ligar Bomba${label}`,
        `Flow#cmd:lig${i}/n`,
        CORES_COMANDO.ligar
      )
    )
    botoes.push(
      criarBotao(
        `Desligar Bomba${label}`,
        `Flow#cmd:des${i}/n`,
        CORES_COMANDO.desligar
      )
    )
  }

  for (let i = 1; i <= inversor; i += 1) {
    const pino = INVERSOR_PINO_INICIAL + i - 1
    const label = sufixo(i, inversor)
    botoes.push(
      criarBotao(
        `Ligar Inversor${label}`,
        `Flow#cmd:lig${pino}:$VALOR/n`,
        CORES_COMANDO.ligar,
        WEG_XMAX,
        WEG_YMAX
      )
    )
    botoes.push(
      criarBotao(
        `Desligar Inversor${label}`,
        `Flow#cmd:des${pino}/n`,
        CORES_COMANDO.desligar
      )
    )
    botoes.push(
      criarBotao(
        `Rotação Inversor${label}`,
        `Flow#cmd:pul${pino}:$VALOR/n`,
        CORES_COMANDO.rotacao,
        WEG_XMAX,
        WEG_YMAX
      )
    )
  }

  if (incluirCmdAuto) {
    botoes.push(
      criarBotao(
        'Set Ativar CMD Auto',
        'Flow#@@#0501/n',
        CORES_COMANDO.ativarCmdAuto
      )
    )
    botoes.push(
      criarBotao(
        'Set Desativar CMD Auto',
        'Flow#@@#0500/n',
        CORES_COMANDO.desativarCmdAuto
      )
    )
  }

  return botoes
}
